import React from 'react'
import { Tab, Tabs } from "@blueprintjs/core";

function VideoTabs({ onChange, value }) {
  const onChangeHandler = React.useCallback((value) => onChange(value), [onChange])

  return (
    <Tabs onChange={onChangeHandler} selectedTabId={value}>
      <Tab id="videos" title="Videos" />
      <Tab id="broadcasts" title="Scheduled Broadcast" />
      <Tab id="archives" title="Archived Videos"/>
    </Tabs>
  )
}

export default VideoTabs;
